/**
 * PLAT-11228: layout math that runs against media with no natural dimensions
 * (the audio-first mp3 plays in a `video` element and reports 0×0) can bake
 * "NaN%" into positional props. The renderer then rejects the ENTIRE
 * setSource call ("Video.x: Expected a number") and silently keeps its
 * last-good composition — black canvas, dead playback, and `stateReady`
 * never latches, which disables autosave. Repair such props in place before
 * any source reaches the renderer.
 */
export interface RepairedLayoutProp {
  id: string | undefined;
  key: string;
}

const POSITIONAL_KEYS = ['x', 'y', 'width', 'height'] as const;

export function repairNaNLayoutProps(elements: unknown): RepairedLayoutProp[] {
  const repaired: RepairedLayoutProp[] = [];
  if (!Array.isArray(elements)) return repaired;
  const visit = (el: any) => {
    if (!el || typeof el !== 'object') return;
    for (const key of POSITIONAL_KEYS) {
      if (typeof el[key] === 'string' && el[key].includes('NaN')) {
        el[key] = key === 'x' || key === 'y' ? '50%' : '100%';
        repaired.push({ id: el.id, key });
      }
    }
    if (Array.isArray(el.elements)) el.elements.forEach(visit);
  };
  elements.forEach(visit);
  return repaired;
}
